// src/data/scamTypeRecommendations.ts
import { ScamTypeKey } from "./cvtiToScamType";

export const scamTypeRecommendations: Record<ScamTypeKey, string> = {
  감정공감형: "마음이 먼저 움직일 땐, \n사실부터 가볍게 확인해보는 게 어때요?",
  절차맹신형: "절차가 익숙하더라도, \n진짜인지 한 번쯤 확인해보면 더 안심돼요.",
  직진반응형: "급할수록 잠깐 멈춰보는 것도 나쁘지 않아요.",
  실험과잉형: "새로운 걸 시도하기 전에, \n한 번쯤 안전도 점검해보면 어때요?",
  신뢰우선형:
    "믿는 마음일수록, 가볍게 의심해보는 습관이 \n더 단단한 신뢰를 만들어줘요.",
  회피수동형: "피하고 싶을수록, \n딱 한 번만 확인해보는 것도 괜찮아요.",
  정보과신형: "자료가 쏟아져도, \n진짜 여부는 꼭 한 번 더 점검해요.",
  선한낙관형: "좋은 사람도 속을 수 있어요. \n한 번쯤 의심해도 괜찮아요.",
  무관심형:
    "미뤄둘수록 위험이 커져요. \n30초만 투자해 확인·차단·신고부터 해보는 게 어때요?",
};
